export function deriveSeverity(
  change: number,
): "critical" | "warning" | "info" {
  const abs = Math.abs(change);
  if (abs >= 5) return "critical";
  if (abs >= 2) return "warning";
  return "info";
}
